export default __webpack_public_path__ + "static/media/mini xmachine_connect.637f7e22.png";